import { render, staticRenderFns } from "./knowledge-dialog.vue?vue&type=template&id=b814f1fc"
import script from "./knowledge-dialog.vue?vue&type=script&lang=js"
export * from "./knowledge-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports